import { FuseLoadable } from '@fuse';
import React from 'react';

export const AreaClienteConfig = {
    settings: {
        layout: {
            config: {}
        }
    },
    routes: [
        {
            path: '/:organizacao/:empresa/areacliente',
            component: FuseLoadable({
                loader: () => import('./AreaClienteApp')
            })
        },
    ]
};
